import { AVALANCHE_C_CHAIN_ID } from '@coti-io/coti-wallet-plugin';
import type { ChainConfig, TokenConfig } from './types';

/** Extra C-Chain portal pairs until `@coti-io/coti-wallet-plugin` ships them. */
const ADDRESSES: Record<string, string> = {
  USDT: '0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7',
  WBTC: '0x0555E30da8f98308EdB960aa94C0Db47230d2B9c',
  WETH: '0x49D5c2BdFfac6CE2BFdB6640F4F80f226bc10bAB',
  'p.USDT': '0xa492A5c5D3bC11f24138A029E0b6083fC4eaab3b',
  'p.WBTC': '0x052777CCCa2577dafbB653db3640504025FcDfEC',
  'p.WETH': '0x2720dFE9766d00CEDE64946A65bFA99F68991E72',
  PrivacyPortalUSDT: '0x9BBf65fE20B871568cE1d34D278460F0c96F624c',
  PrivacyPortalWBTC: '0x15d5b023baB985154Aca592C37C761787b9F0403',
  PrivacyPortalWETH: '0x9C64D0d2DAe8C4aEa5662d4D154f59FDd683ceFC',
};

const pair = (
  symbol: string,
  name: string,
  icon: string,
  decimals: number,
  addressKey: string,
  bridgeAddressKey: string,
): TokenConfig[] => [
  {
    symbol,
    name,
    icon,
    decimals,
    isPrivate: false,
    addressKey,
    bridgeAddressKey,
    supportedChainIds: [AVALANCHE_C_CHAIN_ID],
  },
  {
    symbol: `p.${symbol}`,
    name: `Private ${symbol}`,
    icon,
    decimals,
    isPrivate: true,
    addressKey: `p.${symbol}`,
    bridgeAddressKey,
    supportedChainIds: [AVALANCHE_C_CHAIN_ID],
  },
];

const TOKENS: TokenConfig[] = [
  ...pair('USDT', 'Tether USD', '/icons/usdt.svg', 6, 'USDT', 'PrivacyPortalUSDT'),
  ...pair('WBTC', 'Wrapped BTC', '/icons/wBTC.svg', 8, 'WBTC', 'PrivacyPortalWBTC'),
  ...pair('WETH', 'Wrapped Ether', '/icons/wETH.svg', 18, 'WETH', 'PrivacyPortalWETH'),
];

export const withAvaxMainnetPortals = (config?: ChainConfig): ChainConfig | undefined => {
  if (!config || config.id !== AVALANCHE_C_CHAIN_ID) return config;
  const symbols = new Set(config.tokens.map((token) => token.symbol));
  return {
    ...config,
    addresses: { ...ADDRESSES, ...config.addresses },
    tokens: [...config.tokens, ...TOKENS.filter((token) => !symbols.has(token.symbol))],
  };
};
